// src/services/userService.js
import axios from "axios";
import { buildHeaders } from "./_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}users/`;
const REPORT_LIST_URL = `${process.env.VUE_APP_API_URL}users/report/list`;

class UserService {
  getAll(params = {}, companyId = null) {
    return axios.get(API_URL, { params, headers: buildHeaders({}, companyId) });
  }
  getList(params = {}, companyId = null) {
    return axios.get(REPORT_LIST_URL, { params, headers: buildHeaders({}, companyId) });
  }
  getById(id, companyId = null) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders({}, companyId) });
  }
  create(userData, companyId = null) {
    return axios.post(API_URL, userData, { headers: buildHeaders({}, companyId) });
  }
  update(id, userData, companyId = null) {
    return axios.put(`${API_URL}${id}`, userData, { headers: buildHeaders({}, companyId) });
  }
  delete(id, companyId = null) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders({}, companyId) });
  }
}

export default new UserService();
